export { default as Input } from './Input'

// storyBook
export { Primary as PrimaryInput } from './Input.stories'
export { Disabled as DisabledInput } from './Input.stories'
